export { Icon, IconNames, type IconSizes, type IconProps } from './icon';
export { mapFeatureKeyToIconName } from './map-feature-key-to-icon-name';
